// extracted by mini-css-extract-plugin
export var quantityInput = "_ma-0";